import {
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { useEquipment } from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const DetectorForm = () => {
  const { getValues } = useFormContext();
  const { equipmentList } = useEquipment();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MTextField
          key={"name"}
          name={"name"}
          label={"Detector"}
          type="text"
          fullWidth
          validation={{ required: `El campo detector es requerido` }}
        />
        <MAutocomplete
          key={JSON.stringify(getValues("equipment"))}
          name="equipment"
          options={equipmentList}
          label="Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: `El campo equipo es requerido` }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default DetectorForm;
